import { useSelector } from 'react-redux'
import { projectInfoSelector } from 'store/projects'
import { currentUserSelector } from 'store/users'
import { USER_ROLE } from 'utils/constants'

const { MANAGER } = USER_ROLE

export const usePrevilegies = () => {
  const user = useSelector(currentUserSelector)
  const projectInfo = useSelector(projectInfoSelector)

  const isSuperAdmin = !!user?.is_super_admin

  const isAdmin = !!user?.is_admin || isSuperAdmin

  const projectUser =
    user?.id && Array.isArray(projectInfo?.users)
      ? projectInfo.users.find((member) => member?.id === user.id)
      : undefined

  const isManagerCurrentProject =
    Array.isArray(projectUser?.role) &&
    projectUser.role.some((role) => role?.id === MANAGER)

  const isManager = isAdmin || isManagerCurrentProject

  return {
    isManager,
    isAdmin,
    isSuperAdmin,
  }
}

export const usePrevilegiesGlobal = () => {
  const user = useSelector(currentUserSelector)

  const isSuperAdmin = !!user?.is_super_admin

  const isAdmin = !!user?.is_admin || isSuperAdmin

  const managerInAnyProject =
    Array.isArray(user?.projects) &&
    user.projects.some((project) => project?.role?.id === MANAGER)

  const isManagerGlobal = isAdmin || !!user?.is_manager || managerInAnyProject

  return {
    isManagerGlobal,
    isAdmin,
    isSuperAdmin,
  }
}
